// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"7ca0f71a","404":"597e2125","498":"b3033760","787":"32d0ca75"}[chunkId] + ".chunk.js";
};